<template lang="pug">
listbox.hidden.md_inline-block(
  @update:modelValue="onChange"
  v-model="selectedColor"
  v-slot="{ open }"
)
  .relative
    watch-boolean-slot(:boolean="open" :off="() => onChange(selectedColor)")

    listbox-button.bg-white.rounded-sm.overflow-hidden.flex.items-stretch.justify-start.shadow(
      :class="`primary-${selectedColor}`"
    )
      span.w-8(:class="`bg-primary-500`")
      span.inline-flex.items-center
        span.px-4.text-lg(:class="`text-primary-700`") {{ sentenceCase(level) }}
        uc-icon(icon="mdi:chevron-down")

    listbox-options.absolute.bottom-5.w-full.py-1.mt-1.overflow-auto.text-base.bg-white.rounded.shadow-lg.ring-1.ring-black.ring-opacity-5.focus_outline-none.sm_text-sm.w-32.simple-scrollbar(
      class="z-[1000] max-h-[70vh]"
    )
      listbox-option(
        :key="color"
        :value="color"
        as="template"
        v-for="color in colors"
        v-slot="{ active, selected }"
      )
        li.text-base.flex.items-stretch.justify-start.cursor-default.select-none.transition-colors(
          :class="[`primary-${color}`, { 'bg-primary-200': active }]"
        )
          watch-boolean-slot(:boolean="active" :on="() => onChange(color)")
          span.w-5.flex.items-center(:class="`bg-primary-500`")
            uc-icon.text-white.auto-alpha-0.px-1(
              :class="{ 'auto-alpha-1': selected }"
              icon="theme:check"
            )
          span.inline-flex.items-center
            span.text-primary-700.px-1 {{ color }}
</template>
<script setup lang="ts">
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption
} from '@headlessui/vue';
import { useSafeLocalStorage } from '../lib/safeLocalStorage';
import { defineComponent, nextTick, watch } from 'vue';
import useContent from '../stores/useContent';

const WatchBooleanSlot = defineComponent({
  props: {
    boolean: { type: Boolean, required: true },
    on: { type: Function, default: () => null },
    off: { type: Function, default: () => null }
  },
  watch: {
    boolean(v: boolean) {
      v ? this.on() : this.off();
    }
  },
  render: () => null
});

const props = defineProps({ level: { type: String, default: 'primary' } });

const hues =
  'red orange amber yellow lime green emerald teal cyan sky blue indigo violet purple fuchsia pink rose'.split(
    ' '
  );

const grays = ['slate', 'zinc', 'neutral', 'stone'];
const colors = props.level === 'gray' ? grays : hues;

const { compiled, setPath } = useContent();

const selectedColor = useSafeLocalStorage(
  'uc-color-' + props.level,
  compiled.course?.[props.level]
);

const sentenceCase = (str: string) => str[0].toUpperCase() + str.slice(1);

const onChange = (v: string) => {
  selectedColor.value = v;
};

const updateTheme = (v: string) => {
  setPath(`$course.${props.level}`, v);

  nextTick(() => {
    document
      .getElementById('app')
      ?.dispatchEvent(new CustomEvent('uc:themechange'));
  });
};

watch(
  selectedColor,
  () => {
    updateTheme(selectedColor.value);
  },
  { immediate: true }
);
</script>
